export default {
    activeClientLimit: '有効取引先数の上限',
    addons: '機能',
    billingContact: '請求先',
    billingFrequency: '支払い頻度',
    billingMethod: '支払い方法',
    changeBillingContact: '請求先を変更',
    changeBillingMethod: 'お支払い方法を変更',
    clientsButton: '有効取引先数の上限を変更',
    clientsLabel: '取引先',
    clientsValue: '{{clients}}/{{limit}}（有効取引先数／有効取引先上限）',
    clientsWarning: '制限を調整して、より多くのクライアントを追加',
    gracePeriod: '（プラン移行前）',
    mailPoints: '郵送ポイント',
    mailPointsButton: '郵送ポイントを購入する',
    newPlanStart: '新プラン開始日',
    plan: 'プラン',
    planCancelButton: 'プランをキャンセル',
    planChangeButton: 'プランを変更する',
    price: '価格',
    receipts: '領収書',
    receiptsButton: '領収書発行依頼',
    resetDate: '通数のリセット日：',
    sendOrdersButton: '上限を変更',
    sendOrdersLabel: '送付依頼',
    sendOrdersValue: '{{sent}}/{{limit}}（送付依頼済み／送付依頼上限）',
    sendOrdersWarning:
        'これ以上の送付依頼を作成するには、送付依頼の上限設定を変更してください。',
    teamMembersButton: '一般権限メンバー数の上限を変更',
    teamMembersLabel: 'メンバー',
    teamMembersLimit: '一般権限メンバー数の上限',
    teamMembersValue:
        '{{members}}/{{limit}}（一般権限メンバー数／一般権限上限）',
    title: 'お支払い関連 - MakeLeaps',
    virtualAccounts: '仮想口座',
    virtualAccountsValue: '{{count}}/{{limit}}（割り当て済み／仮想口座上限）',
};
